import {Prefix} from './Prefix'

export const dct: Prefix = new Prefix('http://purl.org/dc/terms/')
export const foaf: Prefix = new Prefix('http://xmlns.com/foaf/0.1/')
export const lexinfo: Prefix = new Prefix('http://www.lexinfo.net/ontology/2.0/lexinfo#')
export const modsci: Prefix = new Prefix('https://w3id.org/skgo/modsci#')
export const rdf: Prefix = new Prefix('http://www.w3.org/1999/02/22-rdf-syntax-ns#')
export const rdfs: Prefix = new Prefix('http://www.w3.org/2000/01/rdf-schema#')
export const owl: Prefix = new Prefix('http://www.w3.org/2002/07/owl#')

export const org: Prefix = new Prefix('http://www.w3.org/ns/org#')
export const rel: Prefix = new Prefix('http://www.perceive.net/schemas/20021119/relationship/#')
export const schema: Prefix = new Prefix('https://schema.org/')
export const scot: Prefix = new Prefix('http://rdfs.org/scot/ns#')
export const skos: Prefix = new Prefix('http://www.w3.org/2004/02/skos/core#')
export const vocang: Prefix = new Prefix('http://www.vocabolangelo.org/')
export const xsd: Prefix = new Prefix('http://www.w3.org/2001/XMLSchema#')
